export default __webpack_public_path__ + "static/media/logo_soft_skills.152dab7f.svg";